import React, { useEffect, useRef, useState } from 'react';
import SignaturePad from "react-signature-canvas";
import Modal from "react-modal";
 
const terms = [
    "1) Prices & Payments: Prices are in US dollars. Payments will be accepted in the form of wire transfers, checks (which can be directly deposited into our account) or cash. All Merchandise will not be released until funds have cleared in our account. We do not accept credit cards. Payment is due for all non-net-term customers after the order is picked.",
    "2) Minimum Purchase Amounts: Minimum order quantities apply on an item by item basis. There is a general <b>$2,500.00</b> minimum order per purchase.",
    "3) Shipping & Deliveries. Shipping is via US Postal Service or UPS Jound unless other arrangements are requested. Customers reserve the right to schedule or arrange for their own shipping or freight. Freight shipping can be arranged by us if requested. Buyer assumes responsibility for all shipping or freight charges unless otherwise agreed upon and mentioned on their invoice. Note: We cannot take responsibility for delays that are beyond our control: for example but not limited to, weather or transit delays. Buyer is responsible for requesting or adding insurance to their own freight even if New York Cosmetics schedules the shipment. New York Cosmetics takes no responsibility for merchandise damaged in transit. Any issues with packages/pallets being lost or damaged must be dealt with directly through the carriers or insurance providers.",
    "4) Return Policy: No Returns. All sales are final. In the event that there was misinformation during the transaction, it must be reported to New York Cosmetics within 3 business days of receiving the merchandise. In the event that New York Cosmetics does approve a return, it may be subject to a 15% restocking fee. Note: New York Cosmetics sells merchandise in conditions other than just brand new. It is the buyer's responsibility to ensure they read all descriptions and details in emails and product offers.",
    "5) Orders: New York Cosmetics reserves the right to refuse any order placed by the customer for any reason.",
    "6) Storage. All orders must be picked up within 14 days of being notified that they are ready to ship or are in stock. It is the buyer's responsibility to ensure that they are removed from the premises. After 30 days, the buyer will be subject to paying a storage fee of $75.00 per pallet position per month.",
    "7) Processing: It a part of your transaction with New York Cosmetics involves us bundling merchandise or prepping your order for Amazon FBA, charges of 50 25 per ASIN label, 50 50 per bundling/poly bagging, and $1.00 per box label may apply unless otherwise agreed upon.",
    "8) Disputes: In the event of a dispute between New York Cosmetics and the buyer, any and all litigation or mediation will take place in the state of New Jersey. Buyer agrees to pay all fees involved.",
    "9) Service Description: New York Cosmetics is a wholesaler and distributor of cosmetics, skincare, and fragrances. We carry a wide array of brands and categories We occasionally buy and sell deals outside of our normal criteria. Unless specifically stated. New York Cosmetics does not claim to be authorized distributors of any of the brands or merchandise that we carry or offer.",
    "10) Subject to Prior Sale: All items are subject to prior sale. The vast majority of merchandise we offer to clients is in stock and in our warehouse, however, we do sometimes offer products that we do not own or that are inbound to our warehouse. Unless otherwise stated, New York Cosmetics does not claim to have merchandise in stock. A reasonable period of time will be given to New York Cosmetics to process and ship all orders. That does not include lead time as they may be given to you either through email or orally.",
    "11) Required Licenses & Taxes: Both parties shall have all the required permits and licenses for the purpose of conducting business through the sales and purchase of wholesale merchandise usually, but not limited to a resale certificate. By signing this agreement you are acknowledging that you do in fact have a resale certificate and that you are tax exempt on your purchase. We take no responsibility in any dealings with the IRS or other government agencies concerning taxes, both federal and state, gross receipts, sales and privilege taxes, duties and import or export fees or similar liabilities on your purchase.",
    "12) Cancellations: Purchase orders and payment subral are legally binding agreements to purchase the merchandise. ALL ORDERS ARE FINAL NO CANCELLATIONS WILL BE ALLOWED FOR THIS REASON, By signing this agreement, the buyer agrees that if they submit a purchase order, they are submitting a legal document guaranteeing the purchase of the goods and that they will submit a payment within 5 business days unless there is a lead time, and it is mentioned on their invoice Failure to remit payment may result in New York Cosmetics acquiring counsel with an attorney to pursue you for the funds, which you are obligated to pay. Buyer pays for all litigation fees.",
    "13) Dating/Batch Codes: All Expiration dates are USUALLY provided at the time that the product is offered. If it is not provided, it is the buyer's resmnsibility to request that information from New York Cosmetics. New York Cosmetics is a closeout company, and some products may have older batch codes or may even be expired. We take no responsibility and will not accept returns due to these reasons. There are also cases where an item only has a batch code, and it is not possible to determine the age of the product. New York Cosmetics does quality control checks on all merchandise to ensure they are not the wrong color, smell, or consistency. Please note, we cannot take responsibility for any Item that is restricted to sell on Amazon, restricted to send to FBA, or restricted on any other marketplaces. It is the buyer's responsibility to make sure before buying that he/she is eligible to sell these products. We do not claim to be authorized resellers or distributors of any of the brands we are offering unless otherwise stated. We also cannot take responsibility for any item that becomes restricted after the sale. We will not be able to cancel any order for this reason after receiving a purchase order or payment. No refund will be issued for any of these reasons. Once New York Cosmetics has a mutual agreement with a buyer that an order is considered finalized, whether in writing or by oral agreement, it CANNOT be canceled & the order is nonrefundable.",
    "I undersigned, warranting that the information contained in this application is true and correct. I accept New York Cosmetics Terms of Sale.",
  ];
 
 
 // TermsOfSales Component
// TermsOfSales Component
const TermsOfSales = ({ formData, handleChange, invalidFields, setInvalidFields }) => {
  const [imageURL, setImageURL] = useState(null);
  const [showPad, setShowPad] = useState(false);
  const sigCanvas = useRef({});
 
  // Function to clear the signature pad
  const clear = () => sigCanvas.current.clear();
 
  // Function to save the signature to session storage
  const saveToSessionStorage = (image) => {
    sessionStorage.setItem('signature', image);
  };
 
  // Function to load the signature from session storage
  const loadFromSessionStorage = () => {
    const storedImage = sessionStorage.getItem('signature');
    if (storedImage) {
      setImageURL(storedImage);
    }
  };
 
  // Function to save the signature
  const save = () => {
    const image = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
    setImageURL(image);
    saveToSessionStorage(image);
    setShowPad(false); // Hide the signature pad after saving
  };
 
  // Function to cancel signature
  const cancel = () => {
    clear();
    setShowPad(false); // Hide the signature pad
  };
 
  useEffect(() => {
    // Set the current date in the format YYYY-MM-DD
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
 
    handleChange({
      target: {
        name: "date",
        value: formattedDate,
      },
    });
 
    // Load the signature from session storage
    loadFromSessionStorage();
  }, [handleChange]);
 
  // Function to handle changes in the Job Title field
  const handleJobTitleChange = (event) => {
    handleChange(event);
 
    // Check if signature exists in session storage
    // const storedSignature = sessionStorage.getItem('signature');
 
    // if (!storedSignature) {
    //   alert("Please do your signature.");
    // }
  };
 
  return (
    <div className="flex flex-col justify-center overflow-hidden py-2">
      <div className="sub-container">
        <h4>NEW YORK COSMETICS - TERMS OF SALE</h4>
        <div className="w-10/12 bg-white p-2">
        {terms.map((term, index) => (
             <p key={index} className="termsText" dangerouslySetInnerHTML={{ __html: term }} />
           ))}
        </div>
      </div>
      <div className="sub-container-1 px-2">
        <div className="form-group px-3 flex gap-2 item-center justify-start">
          <input
            type="checkbox"
            name="termsAccepted"
            checked={formData.termsAccepted}
            onChange={handleChange}
            required
          />
          <label className=' flex gap-0.5 mt-2'>I agree<span className='text-red-700 font-semibold text-md'>*</span></label>
        </div>
 
        <div className="signature-row">
          <div className="inputContainer">
            <label className="label">Signature <span className='text-red-700 font-semibold text-md'>*</span>
              {invalidFields.includes('clientsignature') && (
                <p className='text-red-700 font-semibold text-md'>This field is required.</p>
              )}
            </label>
            <div className="signatureContainer nycfix-sig">
              <div
                className="signbutton"
                onClick={() => setShowPad(true)}
              >
                Sign
              </div>
              {showPad && (
                <Modal
                  isOpen={showPad}
                  onRequestClose={() => setShowPad(false)}
                  contentLabel="Signature Pad"
                  className="Modal"
                  overlayClassName="Overlay"
                >
                  <div className="signaturePad">
                    <label className="padtext">Sign Here</label>
                    <SignaturePad
                      ref={sigCanvas}
                      canvasProps={{ className: "signatureCanvas" }}
                    />
                    <button onClick={clear}>Clear Signature</button>
                    <div className="padbuttonlayout">
                      <button className="padbutton" onClick={cancel}>Cancel</button>
                      <button className="padbutton" onClick={save}>Done</button>
                    </div>
                  </div>
                </Modal>
              )}
              {imageURL && (
                <img
                  src={imageURL}
                  alt="Signature"
                  style={{
                    display: "block",
                    width: "100%",
                    height: "auto",
                    border: "1px solid #000",
                    marginTop: "10px",
                  }}
                />
              )}
            </div>
          </div>
        </div>
 
        <div className="row-column">
          <div className="inputContainer">
            <label className="label flex gap-0.5">Job Title <span className='text-red-700 font-semibold text-md'>*</span>
              {invalidFields.includes('jobTitle') && (
                <p className='text-red-700 font-semibold text-md'>This field is required.</p>
              )}
            </label>
            <input
              type="text"
              className="input"
              placeholder="---"
              name="jobTitle"
              value={formData.jobTitle}
              onChange={handleJobTitleChange}
            />
          </div>
          <div className="inputContainer">
            <label className="label">Date</label>
            <input
              type="date"
              className="input"
              name="date"
              value={formData.date}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
 
export default TermsOfSales;